import cn from '@/utils/tailwind';
import { forwardRef, HTMLProps } from 'react';

export const Input = forwardRef<HTMLInputElement, HTMLProps<HTMLInputElement>>(
  (props: HTMLProps<HTMLInputElement>) => (
    <input type="radio" className={cn('hidden peer', props.className)} {...props} />
  ),
);
